var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
function SvgChange(props) {
  var _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#".concat(_id, ")")
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 46c12.15 0 22-9.85 22-22S36.15 2 24 2 2 11.85 2 24s9.85 22 22 22z",
    fill: "#FFC859"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46 24a22 22 0 01-22 22V2a22 22 0 0122 22z",
    fill: "#FA9C3F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.133 11.978l-.933.924a.933.933 0 01-1.32 0 16.949 16.949 0 00-11.792-5.043A16.016 16.016 0 009.04 18.305a20.105 20.105 0 00-.546 1.954.924.924 0 00.88 1.135h3.52a.923.923 0 00.88-.581 17.367 17.367 0 011.901-3.731 10.718 10.718 0 0116.377-.361.942.942 0 010 1.294l-.88.836a.924.924 0 00.748 1.628h6.846a.923.923 0 00.933-.924v-6.873a.933.933 0 00-1.566-.704zM9.867 36.014l.924-.88a.941.941 0 011.32 0 16.967 16.967 0 0011.801 4.998 16.016 16.016 0 0014.678-9.61c.353-.903.647-1.83.88-2.771a.924.924 0 00-.88-1.153h-3.502a.94.94 0 00-.88.686 10.78 10.78 0 01-10.296 7.612 11.31 11.31 0 01-8.263-3.361.881.881 0 010-1.303l1.082-1.091a.923.923 0 00-.651-1.62H9.234a.932.932 0 00-.933.925v6.872a.924.924 0 001.566.696z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: _id
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(2 2)",
    d: "M0 0h44v44H0z"
  })))));
}
export default SvgChange;